export default __webpack_public_path__ + "static/media/cat2.f9b9c3df.png";